import { login, reset, forgot } from '../../services/auth/auth'

export const auth = {

  namespaced: 'auth',

  state: {
    data: {},
    user: {},
    loading: false,
    error: null
  },

  actions: {

    login ({ state, commit }, data) {
      commit('setLoading', true)
      login(data)
        .then(response => {
          commit('setAuth', response.data.auth)
          window.location.href = './'
          commit('setLoading', false)
        })
        .catch(error => {
          console.log(error)
          commit('setError', error.response.message)
          commit('setLoading', false)
        })
    },

    forgot ({ state, commit }, data) {
      data.redirect = window.location.protocol + '//' + window.location.host + '/reset-password'
      commit('setLoading', true)
      forgot(data)
        .then(response => {
          window.location.href = './login'
          commit('setLoading', false)
        })
        .catch(error => {
          commit('setError', error.response.message)
          commit('setLoading', false)
        })
    },

    reset ({ state, commit }, data) {
      commit('setLoading', true)
      reset(data)
        .then(response => {
          window.location.href = './login'
          commit('setLoading', false)
        })
        .catch(error => {
          commit('setError', error.response.message)
          commit('setLoading', false)
        })
    },

    logout ({ commit }) {
      commit('setLoading', true)
      localStorage.clear()
      window.location.href = './login'
    }
  },

  mutations: {

    setAuth (state, auth) {
      localStorage.token = 'Bearer ' + auth.token
      state.user = {
        name: auth.name,
        email: auth.email,
        type: auth.user_type_id
      }
      localStorage.setItem('user', JSON.stringify(state.user))
    },

    setLoading (state, status) {
      state.loading = status
    }

  },

  getters: {}

}
